import React, { useCallback, useState, useMemo } from "react";
import { RightWrapper, SpaceWrapper } from "../../../components";
import { FaArrowLeft } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import { DropDownInput, Button, InputField } from "@/components";
import { useDispatch, useSelector } from "react-redux";
import { fetchRateData, UpdateSingleRate } from "../../../app/Slices";
import { useAlert, useConfirmationDialog } from "@/";

const courierOptionsArray = [
  { value: "BlueDart", label: "BlueDart" },
  { value: "XpressBees", label: "Xpress Bees" },
  { value: "EconExpress", label: "EconExpress" },
  { value: "Delhivery", label: "Delhivery" },
  { value: "ShadowFax", label: "ShadowFax" },
];
const modeOptionArray = [
  { value: "Air", label: "Air" },
  { value: "Surface", label: "Surface" },
];
const weightBracketoptionArray = [
  { value: 0.5, label: "0.5 Kg" },
  { value: 1, label: "1 Kg" },
  { value: 1.5, label: "1.5 Kg" },
  { value: 2, label: "2 Kg" },
  { value: 2.5, label: "2.5 Kg" },
  { value: 3, label: "3 Kg" },
  { value: 3.5, label: "3.5 Kg" },
  { value: 4, label: "4 Kg" },
  { value: 4.5, label: "4.5 Kg" },
  { value: 5, label: "5 Kg" },
  { value: 6, label: "6 Kg" },
  { value: 7, label: "7 Kg" },
  { value: 8, label: "8 Kg" },
  { value: 9, label: "9 Kg" },
  { value: 10, label: "10 Kg" },
  { value: 11, label: "10+1 Kg" },
];

const EditSingleRate = () => {
  const dispatch = useDispatch();
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const [formData, setFormData] = useState({
    courier: "",
    mode: "",
    weight: "",
  });
  const [zoneData, setZoneData] = useState({
    id: "",
    zone1: "",
    zone2: "",
    zone3: "",
    zone4: "",
    zone5: "",
    zone6: "",
    codAmt: "",
    codPer: "",
    gst: "",
  });

  const courier = useSelector((state) => state.app.appData.courier) || [];
  console.log(courier);
  const courierOptions = useMemo(
    () => courier.map((c) => ({ value: c._id, label: c.name })),
    []
  );

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleZoneChange = (field, value) => {
    setZoneData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const formatDecimal = (value) => {
    // Convert to number and format to 2 decimal places
    return Number(value).toFixed(2);
  };

  const handlefetch = async () => {
    console.log("FormData::::", formData);

    if (!formData.courier || !formData.mode || !formData.weight) {
      alert("Please select all the fields");
      return;
    }

    const courierId = formData.courier;
    const mode = formData.mode;
    const weight = formData.weight;

    try {
      const action = await dispatch(fetchRateData({ courierId, mode, weight }));

      if (fetchRateData.fulfilled.match(action)) {
        console.log("API Response Payload:", action.payload);

        // If response is an array, take the first object
        const data = Array.isArray(action.payload)
          ? action.payload[0]
          : action.payload;

        if (data) {
          setZoneData({
            id: data._id || "",
            zone1: data.zoneRates?.zone1 || "",
            zone2: data.zoneRates?.zone2 || "",
            zone3: data.zoneRates?.zone3 || "",
            zone4: data.zoneRates?.zone4 || "",
            zone5: data.zoneRates?.zone5 || "",
            zone6: data.zoneRates?.zone6 || "",
            codAmt: data.codFixed || "",
            codPer: formatDecimal(data.codPercentage) || "",
            gst: formatDecimal(data.gst) || "",
          });
        }
      } else if (fetchRateData.rejected.match(action)) {
        console.error("API Error:", action.error);
        alert(
          action.error?.message || "Something went wrong while fetching rates."
        );
      }
    } catch (error) {
      console.error("Unexpected API Error:::", error);
    }
  };
  const handleUpdate = async () => {
    console.log("FormData::::", formData.courier);
    console.log("ZoneData::::", zoneData);
    if (
      !zoneData.zone1 ||
      !zoneData.zone2 ||
      !zoneData.zone3 ||
      !zoneData.zone4 ||
      !zoneData.zone5 ||
      !zoneData.zone6 ||
      !zoneData.codAmt ||
      !zoneData.codPer ||
      !zoneData.gst
    ) {
      alert("Please fill all the fields");
      return;
    }
    try {
      await confirm("Are you sure you want to update the rates?");
      const id = zoneData.id;
      const data = {
        zoneRates: {
          zone1: zoneData.zone1,
          zone2: zoneData.zone2,
          zone3: zoneData.zone3,
          zone4: zoneData.zone4,
          zone5: zoneData.zone5,
          zone6: zoneData.zone6,
        },
        codFixed: zoneData.codAmt,
        codPercentage: zoneData.codPer,
        gst: zoneData.gst,
      };
      const action = await dispatch(UpdateSingleRate({ id, data }));

      if (UpdateSingleRate.fulfilled.match(action)) {
        console.log("API Response Payload:", action.payload);
        alert("Rates updated successfully");
      } else if (UpdateSingleRate.rejected.match(action)) {
        console.error("API Error:", action.error);
        alert(
          action.error?.message || "Something went wrong while updating rates."
        );
      }
    } catch (error) {
      console.error("Unexpected API Error:::", error);
    }
  };
  return (
    <SpaceWrapper>
      <div className="w-full flex-1 flex flex-col gap-6 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        <h2 className="flex items-center gap-1  text-headline4 lg:text-headline3 font-nunito font-bold text-secondary/95">
          <FaArrowLeftLong
            // onClick={}
            className="text-headline4 lg:text-headline3 text-secondary/70 font-nunito  cursor-pointer"
          />
          Update Specific Rates
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 items-end ">
          <DropDownInput
            label="Courier Partner"
            placeholder="Select courier partner"
            options={courierOptions}
            value={formData.courier}
            onChange={(value) => handleChange("courier", value)}
          />
          <DropDownInput
            label="Mode"
            placeholder="Select mode"
            options={modeOptionArray}
            value={formData.mode}
            onChange={(value) => handleChange("mode", value)}
          />
          <DropDownInput
            label="Weight"
            placeholder="Select weight"
            options={weightBracketoptionArray}
            value={formData.weight}
            onChange={(value) => handleChange("weight", value)}
          />
          <div className="flex flex-row gap-2 justify-start items-end">
            <Button
              variant="default"
              size="sm"
              onClick={handlefetch}
              className="h-12"
            >
              Fetch Rates
            </Button>
          </div>
        </div>
        <div className="flex flex-col gap-4 p-4 border-[1.6px] border-secondary/35 rounded-xl">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-2 lg:gap-4 items-end ">
            <InputField
              label="Zone 1"
              placeholder="Enter zone 1"
              value={zoneData.zone1} //
              onChange={(value) => handleZoneChange("zone1", value)} //
            />
            <InputField
              label="Zone 2"
              placeholder="Enter zone 2"
              value={zoneData.zone2} //
              onChange={(value) => handleZoneChange("zone2", value)} //
            />
            <InputField
              label="Zone 3"
              placeholder="Enter zone3"
              value={zoneData.zone3} //
              onChange={(value) => handleZoneChange("zone3", value)} //
            />
            <InputField
              label="Zone 4"
              placeholder="Enter zone 4"
              value={zoneData.zone4} //
              onChange={(value) => handleZoneChange("zone4", value)} //
            />
            <InputField
              label="Zone 5"
              placeholder="Enter zone 5"
              value={zoneData.zone5} //
              onChange={(value) => handleZoneChange("zone5", value)} //
            />
            <InputField
              label="Zone 6"
              placeholder="Enter zone 6"
              value={zoneData.zone6} //
              onChange={(value) => handleZoneChange("zone6", value)} //
            />
            <InputField
              label="COD Amt."
              placeholder="Enter cod amount"
              value={zoneData.codAmt} //
              onChange={(value) => handleZoneChange("codAmt", value)} //
            />
            <InputField
              label="COD %"
              placeholder="Enter cod percentage"
              value={zoneData.codPer} //
              onChange={(value) => handleZoneChange("codPer", value)} //
            />
            <InputField
              label="GST %"
              placeholder="Enter gst percentage"
              value={zoneData.gst} //
              onChange={(value) => handleZoneChange("gst", value)} //
            />
          </div>
          <div className="flex  justify-center items-center ">
            <Button
              variant="default"
              size="sm"
              className="h-12 py-4 px-16"
              onClick={handleUpdate}
            >
              Update Rates
            </Button>
          </div>
        </div>
      </div>
      <ConfirmationModal />
      <AlertDialog />
    </SpaceWrapper>
  );
};

export default EditSingleRate;
